import { Button, Grid, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { COLOR_DARK } from "./theme";

export function Header({ label, home }: { label: string, home: boolean }): ReactElement {
  return (<Grid item xs={12} sx={{ mt: 4 }} >
    <img src={"/kincyte/KinCytE_Logo_569x205px.png"}
      alt="Kincyte Logo"
      style={{
        height: '65px',
        transform: 'translate(-5px, 0px)',
      }}
    />
    {
      home &&
      <Grid item xs={12} sx={{ mb: 4 }} >
        <Button size="medium" href="/kincyte" sx={{ pt: 0 }} startIcon={<ArrowBackIcon htmlColor={COLOR_DARK} />}>
          Home
        </Button>
      </Grid>
    }
    <Typography variant='h1' sx={{ mt: '40px' }}>{label}</Typography>
  </Grid >
  );
}